exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .v-content{transition:none;display:flex;flex:1 0 auto;max-width:100%}.qmodii .v-content[data-booted=true]{transition:.2s cubic-bezier(.4,0,.2,1)}.qmodii .v-content__wrap{flex:1 1 auto;max-width:100%;position:relative}@-moz-document url-prefix(){@media print{.qmodii .v-content{display:block}}}", ""]);

// exports
